import { Controller } from "@hotwired/stimulus"

// Hamburger button in the top navbar that collapses the sidebar.
export default class extends Controller {
  toggle() {
    const sidebar = document.getElementById("sidebar")
    if (!sidebar) return

    sidebar.classList.toggle("collapsed")
    // Let charts/tables re-layout once the sidebar animation has finished.
    sidebar.addEventListener("transitionend", () => window.dispatchEvent(new Event("resize")), { once: true })
  }
}
